type Rated = {
  rating: number | null;
  reviewCount: number | null;
};

/** Average weighted by review count, rounded to one decimal, over the items that carry a rating. */
export const getWeightedRating = (items: Array<Rated | null | undefined>) => {
  const rated = items.filter((item): item is Rated => {
    return !!item && item.rating !== null && item.reviewCount !== null && item.reviewCount > 0;
  });

  if (!rated.length) {
    return null;
  }

  const count = rated.reduce((total, item) => {
    return total + (item.reviewCount ?? 0);
  }, 0);

  const weightedSum = rated.reduce((total, item) => {
    return total + (item.rating ?? 0) * (item.reviewCount ?? 0);
  }, 0);

  return {
    average: Math.round((weightedSum / count) * 10) / 10,
    count,
  };
};

export const formatRating = (rating: number) => {
  return rating.toFixed(1);
};

export const formatReviewCount = (count: number) => {
  return `${count} ${count === 1 ? "review" : "reviews"}`;
};
